import type { FunctionComponent } from 'react';

import { UnstyledButton } from '@mantine/core';

import { CLEAR_BUTTON_STYLE } from 'components/MenuManagement/inputConstants';
import { useTranslation } from 'i18n';

import { CloseIconSm } from '@chownow/pantry/icons';

const NS = 'menuManagement';

type ClearInputButtonProps = {
  onClick: () => void;
  show: boolean;
};

export const ClearInputButton: FunctionComponent<ClearInputButtonProps> = ({ onClick, show }) => {
  const { t } = useTranslation(NS);
  return (
    <UnstyledButton
      aria-label={t('ClearInputButton.clearInputAriaLabel')}
      onClick={onClick}
      style={{ display: show ? 'flex' : 'none', ...CLEAR_BUTTON_STYLE }}
    >
      <CloseIconSm />
    </UnstyledButton>
  );
};
